import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';
import * as noUiSlider from 'nouislider';

@createModule('InputRangeSlider')
/**
 * input-range-slider module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */
export class InputRangeSlider extends TerrificSpec {
	slider: noUiSlider.Instance;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		const $ctx = $(this._ctx);

		let valueMin = $(this._ctx).data('value-min') as number;
		let valueMax = $(this._ctx).data('value-max') as number;

		let rangeMin = $(this._ctx).data('range-min') as number;
		let rangeMax = $(this._ctx).data('range-max') as number;

		let decimalSeparator = $(this._ctx).data('decimal-separator');

		this.slider = $(this._ctx).find('.a-input-range-slider__container')[0] as noUiSlider.Instance;

		let numberOfDecimals = this._calcNumberOfDecimals(rangeMin, rangeMax);
		let marginBetweenHandles = this._calcMarginBetweenHandles(rangeMin, rangeMax);

		//const wNumb = require("wnumb");

		noUiSlider.create(this.slider, {
			start: [valueMin, valueMax],
			connect: true,
			tooltips: [true, true],
			margin: marginBetweenHandles,
			range: {
				min: rangeMin,
				max: rangeMax,
			},

			format: wNumb({
				decimals: numberOfDecimals,
				mark: decimalSeparator,
			}),
		});

		this.slider.noUiSlider.on('update', (values, handle) => {
			$ctx.find('.js-handle-' + handle).val(values[handle]);
			this._triggerChangeEvent(values);
		});

		this.slider.noUiSlider.on('start', (values, handle) => {
			$ctx.find("[data-handle='" + handle + "'] .noUi-tooltip").addClass('noUi-tooltip--active');
		});

		this.slider.noUiSlider.on('end', (values, handle) => {
			$ctx.find("[data-handle='" + handle + "'] .noUi-tooltip").removeClass('noUi-tooltip--active');
		});

		this.slider.noUiSlider.on('change', (values, handle) => {
			$ctx.find('.js-handle-' + handle).val(values[handle]);
			this._triggerReleaseEvent(values);
		});


		resolve();
	}

	_calcNumberOfDecimals(rangeMin: number, rangeMax: number) {
		let range = this._calcRange(rangeMax, rangeMin);
		let numberOfDecimals = 1;

		switch (true) {
			case range <= 10:
				numberOfDecimals = 2;
				break;
			case range > 1000:
				numberOfDecimals = 0;
				break;
			default:
				numberOfDecimals = 1;
		}
		return numberOfDecimals;
	}

	_calcMarginBetweenHandles(rangeMin: number, rangeMax: number) {
		let range = this._calcRange(rangeMax, rangeMin);
		let marginBetweenHandles = range * 0.05;
		let widthOfRangerSlider = $(this._ctx).width();

		switch (true) {
			case widthOfRangerSlider <= 400:
				marginBetweenHandles = marginBetweenHandles * 2;
				break;
			case widthOfRangerSlider > 700:
				return marginBetweenHandles;
			default:
				marginBetweenHandles = marginBetweenHandles * 1.5;
		}

		return marginBetweenHandles;
	}

	_calcRange(rangeMin: number, rangeMax: number) {
		return Math.abs(rangeMax - rangeMin);
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}

	/**
	 * method to trigger public event
	 *
	 * @returns {void}
	 */
	_triggerChangeEvent(value: Object) {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx, value);
	}

	/**
	 * method to trigger public event
	 *
	 * @returns {void}
	 */
	_triggerReleaseEvent(value: Object) {
		triggerPublicEvent(PublicEvents.uxSubmit, this, this._ctx, value);
	}

	adjustSlider(leftHandleValue: number, rightHandleValue: number) {
		this.slider.noUiSlider.set([leftHandleValue, rightHandleValue]);
	}
}
